export default {
  init() {
    //If needed to clone nav links
    window.scrollTo({top: 0});
    if (!($('.header').hasClass('white'))) {
      if (window.innerWidth > 991) {

        //Desktop
        $('.header__links__link__block').each(function () {
          $(this).find('a').clone().appendTo(this);
        });
        $('.header__links__link__block a:last-child').addClass('clone');
      } else {

        // Mobile & Tablet
        document.querySelector('.header__mobile__burger').classList.add('clone');
      }
    }

    //Header Links
    $('.header__links__link__block').on('mouseenter', function () {
      $('.header__links__submenu').removeClass('open');
      $(this).next().addClass('open');
    });
    $('.header__links__submenu').on('mouseleave', function () {
      $('.header__links__submenu').removeClass('open');
    });
    $('.header__mobile__burger').on('click', function () {
      $('.header__mobile__submenu').removeClass('open');
      $('.btn-link--primary--mob').removeClass('active');
      $('html, body').toggleClass('fixed');
      $(this).toggleClass('open');
      $('.header__mobile').toggleClass('open');

      if (window.innerWidth > 991)
        $('.header').addClass('white');
      else
        $('.header').toggleClass('white');
    });
    $('.btn-link--primary--mob[href="#"]').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).parent().next().toggleClass('open');
    });

    //Mobile
    if ((window.innerWidth < 992) && (window.innerWidth > 576)) {
      setTimeout(function () {
        $('.header__links').css('right', '' + $('.container').offset().left +'px');
      },300);
    }

    //  Footer Actions
    $('#btn-up').on('click', function () {
      window.scrollTo({top: 0, behavior: 'smooth'});
    });
    // IE fix
    if (navigator.userAgent.search(/MSIE/) > 0 || navigator.userAgent.search(/NET CLR /) > 0) {
      $('.footer__social a').hover(function () {
        $(this).css('animation', 'shaking 0.2s infinite');
      }, function () {
        $(this).css('animation', 'none');
      });
    }
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js